<template>
  <div class="flex cursor-pointer items-baseline" :class="textColorClass" @click="onClick">
    <div class="relative">
      <el-checkbox :disabled="disabled" @change.native.stop="onClick" :label="label" ref="checkbox">
        <span></span>
      </el-checkbox>
      <div class="absolute inset-0 z-10"></div>
    </div>
    <div class="flex-1">
      <slot />
    </div>

    <div v-if="tip">
      <el-tooltip effect="light" :content="tip" popper-class="answer-tooltip">
        <span class="text-medium ml-1">
          <i class="el-icon-question"></i>
          <span class="text-small text-theme-black-350" v-if="answerTipIconText">{{ answerTipIconText }}</span>
        </span>
      </el-tooltip>
    </div>
  </div>
</template>

<script>
import { Message } from 'dygc-ui'

export default {
  name: 'AdapterCheckbox',
  inject:{
    view:{
      default:false
    }
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: null,
      default: ''
    },
    richText: {
      type: String,
      default: ''
    },
    tip: {
      type: String,
      default: ''
    },
    isCorrect: {
      type: Boolean,
      default: false
    },
    exclusiveIds: {
      type: Array,
      default: () => []
    },
    max: {
      type: Number,
      default: -1
    }
  },
  computed: {
    answerTipIconText(){
      if(!this.$bus) return ''
      return this.$bus.survey?.otherSetting?.answerTipIconText
    },
    textColorClass() {
      return this.disabled ? 'text-theme-black-450' : 'text-theme-black-850'
    }
  },
  methods: {
    onClick(v) {
      if (this.disabled || this.view) return
      const checkbox = this.$refs.checkbox
      let list = checkbox.model.slice()
      let index = list.indexOf(this.label)
      if (index > -1) {
        list.splice(index, 1)
      } else {
        list.push(this.label)
      }
      const exclusiveIds = this.exclusiveIds.slice()
      if (exclusiveIds.includes(this.label)) {
        if (index > -1) {
          list = []
        } else {
          list = [this.label]
        }
      } else {
        list = list.filter(id => !exclusiveIds.includes(id))
      }
      let max = this.max
      if (max && max > 0) {
        if (list.length > max) {
          Message.warning(`最多选择${max}项`)
          return
        }
      }
      checkbox.model = list
    }
  }
}
</script>
